export const routesCollectionGuard = 'GET /logistics-route';
export const routesResourceGuard = 'GET /logistics-route/d+';
export const routesRegExpCollectionGuard =
  'GET /logistics-route/[a-zA-Z0-9- ]+';
export const editRoutesResourceGuard = 'PUT /logistics-route/d+';
export const createRoutesResourceGuard = 'POST /logistics-route';
export const deleteRoutesResourceGuard = 'DELETE /logistics-route/d+';
